import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import { db } from '../db/shiksha-db';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Uncaught React Exception:', error, errorInfo);
  }

  handleReset = async () => {
    // Clear local storage / session storage
    localStorage.clear();
    sessionStorage.clear();
    
    // Safely clear only cache tables, preserving offline sync queues!
    try {
      await db.transaction('rw', db.students, db.marks, db.schemas, db.attendance, db.teachers, db.coScholastic, async () => {
        await db.students.clear();
        await db.marks.clear();
        await db.schemas.clear();
        await db.attendance.clear();
        await db.teachers.clear();
        await db.coScholastic.clear();
      });
    } catch (e) {
      console.error('Failed to clear IDB caches', e);
    }
    
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
          <div className="max-w-md w-full bg-white rounded-lg shadow-sm border border-red-200 p-8 text-center">
            <div className="mx-auto bg-red-100 w-16 h-16 rounded-full flex items-center justify-center mb-6">
              <AlertTriangle className="w-8 h-8 text-red-600" />
            </div>
            <h1 className="text-2xl font-bold text-gray-900 mb-2">Oops! Something went wrong.</h1>
            <p className="text-gray-600 mb-6">
              A critical rendering error occurred. Please clear your cache and try reloading the application.
            </p>
            <div className="bg-gray-100 p-4 rounded text-left text-xs text-gray-500 overflow-x-auto mb-6">
              <code>{this.state.error?.toString() || 'Unknown Error'}</code>
            </div>
            <button
              onClick={this.handleReset}
              className="w-full flex items-center justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-red-600 hover:bg-red-700"
            >
              <RefreshCw className="w-4 h-4 mr-2" />
              Clear Cache & Reload App
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
